import React from "react";
import { Field } from "../config/companies/config";
import FieldDisplay from "./FieldDisplay";
import { getBoardValueStyleByRules } from "../utils/boardValueStyle";

type BoardDisplayProps = {
  field: Field;
  value: any;
  item?: any;
};

const BoardDisplay = ({ field, value, item }: BoardDisplayProps) => {
  return (
    <FieldDisplay
      field={field}
      value={value}
      item={item}
      valueStyle={{
        ...(getBoardValueStyleByRules(value, field.boardValueColorRules) ?? {}),
        ...(field.boardValueBold ? { fontWeight: "700" as const } : {}),
      }}
    />
  );
};

export default BoardDisplay;
